import { useState, useEffect } from "react";
import { Button, Card, CardBody, Container } from "reactstrap";
import { useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReportSelector from "../components/Reports/ReportSelector";
import { CallGetReportByUserDataId } from "services/apiAction";
import { message, Spin as AntSpinner } from "antd";

const Report = () => {
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  const [loader, setLoader] = useState(false);

  const params = useParams();

  message.config({ placement: "topRight" });

  useEffect(() => {
    fetchAPI();
  }, []);

  const fetchAPI = async () => {
    setPageLoader(true);
    try {
      const response = await CallGetReportByUserDataId(params.id);

      if (response?.data?.message === "Success") {
        setData(response.data.Report);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to load report data");
    }

    setLoading(false);
    setPageLoader(false);
  };
  const handleReportChange = () => {
    setPageLoader(true);
    setTimeout(() => setPageLoader(false), 800);
  };

  const captureAndConvertPages = async () => {
    try {
      setLoader(true);
      message.loading({
        content: "Please wait... generating PDF",
        key: "printMsg",
        duration: 0,
      });

      const pdf = new jsPDF("landscape", "mm", [297, 210]);
      const pages = document.querySelectorAll(".pageToCapture");

      for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i]);
        const imgData = canvas.toDataURL("image/jpeg", 0.95);

        if (i !== 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, 0, 297, 210);
      }

      pdf.save(
        `${data?.[0]?.userDataId?.firstName || "User_Report"}_${
          data?.[0]?.userDataId?.mobile || ""
        }.pdf`
      );

      message.success({
        content: "Report downloaded successfully!",
        key: "printMsg",
        duration: 2,
      });
    } catch (error) {
      console.error(error);
      message.error({
        content: "Failed to generate report",
        key: "printMsg",
        duration: 2,
      });
    } finally {
      setLoader(false);
    }
  };
  const showMainLoader = loading || pageLoader || loader;

  return (
    <>
      {showMainLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "80%",
            height: "100%",
            marginLeft: "260px",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(6px)",
            zIndex: 9999,
          }}
        >
          <AntSpinner spinning={true} size="medium" style={{ width: "3rem", height: "3rem" }} />
        </div>
      )}
      <div className={showMainLoader ? "blur-background" : ""}>
        <Container className="mt-4" fluid>
          <Card>
            <CardBody>
              <ReportSelector data={data} onChange={handleReportChange} />

              <div className="text-center mt-3 select-box">
                <Button
                  color="primary"
                  onClick={captureAndConvertPages}
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <AntSpinner size="small" /> please wait...
                    </>
                  ) : (
                    "Print"
                  )}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>

      <style>{`
        .blur-background {
          filter: blur(3px);
          pointer-events: none;
          user-select: none;
        }
      `}</style>
    </>
  );
};

export default Report;